import React from 'react';
import { SkipLink, SkipWrapper } from './styles';

const SkipToMain: React.FC = () => {
  return (
    <SkipWrapper id="skip-to-main">
      <SkipLink href="#content">Skip to main content</SkipLink>
    </SkipWrapper>
  );
};

export default SkipToMain;
